import { ActionIcon, Group, Paper, Title } from '@mantine/core';
import { PlusCircleIcon } from 'lucide-react';
import styles from './AddInsuranceCasePanel.module.css';

const AddInsuranceCasePanel = ({
  panelTitle,
  onAddInsuranceCase,
  accessibilityLabel,
}: {
  panelTitle: string;
  onAddInsuranceCase: () => void;
  accessibilityLabel: string;
}) => {
  return (
    <Paper
      role={'button'}
      aria-label={accessibilityLabel}
      withBorder
      radius='xl'
      py='xs'
      px='md'
      onClick={onAddInsuranceCase}
      className={styles.addInsuranceCaseCard}
    >
      <Group gap='md' h='28px'>
        <ActionIcon c='text' variant='transparent'>
          <PlusCircleIcon
            size={16}
            strokeWidth={1.5}
            style={{ color: 'var(--mantine-color-text)' }}
          />
        </ActionIcon>

        <Title
          order={3}
          size='h4'
          fw={600}
          style={{ margin: '0', color: 'var(--mantine-color-text)' }}
        >
          {panelTitle}
        </Title>
      </Group>
    </Paper>
  );
};

export default AddInsuranceCasePanel;
